var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 7.5884V24.4116C32 28.6027 28.6027 32 24.4116 32H7.5884C3.39731 32 0 28.6027 0 24.4116V7.5884C0 3.39732 3.39731 0 7.5884 0H24.4116C28.6027 0 32 3.39732 32 7.5884Z",
    fill: "url(#paint0_linear_123_57393)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5739 5.11719H11.4839C8.07802 5.11719 5.30713 7.88809 5.30713 11.2947V20.3846C5.30713 23.7905 8.07802 26.5621 11.4839 26.5621H20.5739C23.9798 26.5621 26.7507 23.7912 26.7507 20.3846V11.294C26.7507 7.88809 23.9798 5.11719 20.5739 5.11719ZM24.5625 20.3839C24.5625 22.5833 22.7733 24.3726 20.5739 24.3726H11.4839C9.28455 24.3726 7.49526 22.5833 7.49526 20.3839V11.294C7.49526 9.09461 9.28455 7.30533 11.4839 7.30533H20.5739C22.7733 7.30533 24.5625 9.09461 24.5625 11.294V20.3839Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0284 10.8594C13.2826 10.8594 11.0488 13.0932 11.0488 15.8389C11.0488 18.5847 13.2826 20.8185 16.0284 20.8185C18.7741 20.8185 21.0079 18.5847 21.0079 15.8389C21.0079 13.0932 18.7741 10.8594 16.0284 10.8594ZM16.0284 18.5291C14.5447 18.5291 13.3382 17.3226 13.3382 15.8389C13.3382 14.3553 14.5447 13.1487 16.0284 13.1487C17.512 13.1487 18.7186 14.3553 18.7186 15.8389C18.7186 17.3226 17.5114 18.5291 16.0284 18.5291Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6084 8.69922C20.7928 8.69922 20.1313 9.3607 20.1313 10.1763C20.1313 10.9919 20.7928 11.6534 21.6084 11.6534C22.424 11.6534 23.0855 10.9919 23.0855 10.1763C23.0855 9.3607 22.4247 8.69922 21.6084 8.69922Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_123_57393",
    x1: 27.4672,
    y1: 6.2368,
    x2: 4.44574,
    y2: 25.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8237E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0772,
    stopColor: "#9931CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2542,
    stopColor: "#C925A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3895,
    stopColor: "#E71D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4661,
    stopColor: "#F21A80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F89D2E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1229a1457015c11df33b40feb7b4bd47.svg";
export { ForwardRef as ReactComponent };